import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _cloneDeep from "lodash/cloneDeep";
import { useCallback, useMemo } from "react";
import { useQuery } from "@apollo/client";
var GET_USER_TRACKS = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "GetUserTeamsQuery"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "after"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "first"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "userId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "organizationSlug"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "filterBY"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "TeamSearchFilterEnum"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "searchKey"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "userTeams"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "userId"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "userId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "organizationSlug"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "organizationSlug"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "filterBy"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "filterBY"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "searchKey"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "searchKey"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "first"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "first"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "after"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "after"
            }
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "pageInfo"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hasNextPage"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hasPreviousPage"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "startCursor"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "endCursor"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "totalCount"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "edges"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "node"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "originalId"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "teamId"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "isActive"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "expirationDate"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "academyName"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "teamName"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "coursesSummary"
                    },
                    arguments: [],
                    directives: [],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "totalCourses"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "requiredCourses"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "requiredProjects"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "inProgressCourses"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "createdProjects"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "isCompleted"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "requiredQuizCourses"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "completedQuizCourses"
                        },
                        arguments: [],
                        directives: []
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "assignedCourses"
                    },
                    arguments: [],
                    directives: [],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "courseId"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "isRequired"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "isRequiredProject"
                        },
                        arguments: [],
                        directives: []
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "team"
                    },
                    arguments: [],
                    directives: [],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "name"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "hasIntegrations"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "description"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "teamImage"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "track"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "name"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "iconSource"
                            },
                            arguments: [],
                            directives: []
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "reward"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "originalId"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "numberCourses"
                            },
                            arguments: [],
                            directives: []
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "userReward"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "originalId"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "status"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "completedCourses"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "totalProject"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "completedProject"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "courseProgress"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "totalCourses"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "projectProgress"
                            },
                            arguments: [],
                            directives: []
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "skill"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "completedSkillCount"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "totalSkillCount"
                            },
                            arguments: [],
                            directives: []
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "userSkill"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "isActive"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "status"
                            },
                            arguments: [],
                            directives: []
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "academy"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "originalId"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "name"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "logo"
                            },
                            arguments: [],
                            directives: []
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "teamImageV2"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "url"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "placeholder"
                            },
                            arguments: [],
                            directives: []
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "endDate"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "isHidden"
                        },
                        arguments: [],
                        directives: []
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 1806,
    source: {
      body: "query GetUserTeamsQuery(\n  $after: String\n  $first: Int\n  $userId: ID!\n  $organizationSlug: String!\n  $filterBY: TeamSearchFilterEnum\n  $searchKey: String\n) {\n  userTeams(\n    userId: $userId\n    organizationSlug: $organizationSlug\n    filterBy: $filterBY\n    searchKey: $searchKey\n    first: $first\n    after: $after\n  ) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      node {\n        originalId\n        teamId\n        isActive\n        expirationDate\n        academyName\n        teamName\n        coursesSummary {\n          totalCourses\n          requiredCourses\n          requiredProjects\n          inProgressCourses\n          createdProjects\n          isCompleted\n          requiredQuizCourses\n          completedQuizCourses\n        }\n        assignedCourses {\n          courseId\n          isRequired\n          isRequiredProject\n        }\n        team {\n          name\n          hasIntegrations\n          description\n          teamImage\n          track {\n            name\n            iconSource\n          }\n          reward {\n            originalId\n            numberCourses\n          }\n          userReward {\n            originalId\n            status\n            completedCourses\n            totalProject\n            completedProject\n            courseProgress\n            totalCourses\n            projectProgress\n          }\n          skill {\n            completedSkillCount\n            totalSkillCount\n          }\n          userSkill {\n            isActive\n            status\n          }\n          academy {\n            originalId\n            name\n            logo\n          }\n          teamImageV2 {\n            url\n            placeholder\n          }\n          endDate\n          isHidden\n        }\n      }\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
import { formatAcademyImage } from "./utils/formatAcademyImage";
var TEAMS_FIRST = 12;
var useUserTracks = function useUserTracks(_ref) {
  var _data$userTeams3, _data$userTeams4, _data$userTeams5, _data$userTeams5$page;
  var userId = _ref.userId,
    organizationSlug = _ref.organizationSlug,
    filterBY = _ref.filterBY,
    searchKey = _ref.searchKey,
    isFFTracks = _ref.isFFTracks,
    skip = _ref.skip;
  var skipQuery = !userId || skip;
  var variables = {
    userId: String(userId),
    organizationSlug: organizationSlug,
    filterBY: filterBY,
    searchKey: searchKey,
    first: isFFTracks ? TEAMS_FIRST : undefined
  };
  var _useQuery = useQuery(GET_USER_TRACKS, {
      skip: skipQuery,
      variables: variables,
      context: {
        clientName: 'v4.b2b'
      },
      fetchPolicy: 'network-only'
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error,
    refetch = _useQuery.refetch,
    fetchMore = _useQuery.fetchMore;
  var onFetchMore = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _data$userTeams, _data$userTeams$pageI;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!data || loading || !((_data$userTeams = data.userTeams) !== null && _data$userTeams !== void 0 && (_data$userTeams$pageI = _data$userTeams.pageInfo) !== null && _data$userTeams$pageI !== void 0 && _data$userTeams$pageI.hasNextPage))) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (fetchMore) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            _context.next = 6;
            return fetchMore({
              variables: {
                after: data.userTeams.pageInfo.endCursor
              }
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onFetchMore() {
      return _ref2.apply(this, arguments);
    };
  }();
  var teams = useMemo(function () {
    var _data$userTeams2;
    return ((data === null || data === void 0 ? void 0 : (_data$userTeams2 = data.userTeams) === null || _data$userTeams2 === void 0 ? void 0 : _data$userTeams2.edges) || []).filter(function (team) {
      var _team$node$coursesSum;
      return (((_team$node$coursesSum = team.node.coursesSummary) === null || _team$node$coursesSum === void 0 ? void 0 : _team$node$coursesSum.totalCourses) || 0) > 0;
    }).map(function (team) {
      var _customTeam$team, _customTeam$team$acad;
      var customTeam = _cloneDeep(team.node);
      if ((_customTeam$team = customTeam.team) !== null && _customTeam$team !== void 0 && (_customTeam$team$acad = _customTeam$team.academy) !== null && _customTeam$team$acad !== void 0 && _customTeam$team$acad.logo) {
        customTeam.team.academy.logo = formatAcademyImage(customTeam.team.academy.logo);
      }
      return customTeam;
    });
  }, [data === null || data === void 0 ? void 0 : (_data$userTeams3 = data.userTeams) === null || _data$userTeams3 === void 0 ? void 0 : _data$userTeams3.edges]);
  var findCourseById = useCallback(function (courseId) {
    return teams.map(function (team) {
      return team.assignedCourses || [];
    }).flat().find(function (course) {
      return course.courseId === courseId;
    });
  }, [teams]);
  var isRequiredProjectCourse = useCallback(function (courseId) {
    var _findCourseById;
    return !!((_findCourseById = findCourseById(courseId)) !== null && _findCourseById !== void 0 && _findCourseById.isRequiredProject);
  }, [findCourseById]);
  var isRequiredCourse = useCallback(function (courseId) {
    var _findCourseById2;
    return !!((_findCourseById2 = findCourseById(courseId)) !== null && _findCourseById2 !== void 0 && _findCourseById2.isRequired);
  }, [findCourseById]);
  return {
    loading: loading,
    data: teams,
    totalCount: (data === null || data === void 0 ? void 0 : (_data$userTeams4 = data.userTeams) === null || _data$userTeams4 === void 0 ? void 0 : _data$userTeams4.totalCount) || 0,
    isRequiredCourse: isRequiredCourse,
    isRequiredProjectCourse: isRequiredProjectCourse,
    error: error,
    refetch: refetch,
    nextPage: Boolean(data === null || data === void 0 ? void 0 : (_data$userTeams5 = data.userTeams) === null || _data$userTeams5 === void 0 ? void 0 : (_data$userTeams5$page = _data$userTeams5.pageInfo) === null || _data$userTeams5$page === void 0 ? void 0 : _data$userTeams5$page.hasNextPage),
    onFetchMore: onFetchMore
  };
};
export default useUserTracks;